import useFacilitiesDropdownStore, {
  IFacilitiesDropdownState,
} from "../../../common/components/dropdowns/facilities-dropdown/api/store";
import useProductDropdownStore, {
  IProductDropdownState,
} from "../../../common/components/dropdowns/products-dropdown/api/store";
import useNotificationsStore, {
  INotificationsState,
} from "../../../common/components/notifications/api/store";
import queryClient from "../../../common/query-client";
import { AllGroups, clientModel } from "../../client/api/types";
import { ProductListModel } from "../../products/api/types";
import { UserModel } from "../../users-facility/api/types";
import { IMainState } from "./store";

export class Handlers {
  private mainStore: IMainState;
  private notificationStore: INotificationsState;
  private productDDStore: IProductDropdownState;
  private facilityDDStore: IFacilitiesDropdownState;

  constructor(mainStore: IMainState) {
    this.mainStore = mainStore;
    this.notificationStore = useNotificationsStore.getState();
    this.productDDStore = useProductDropdownStore.getState();
    this.facilityDDStore = useFacilitiesDropdownStore.getState();
  }

  handleSetCurrentUser = (user: UserModel) => {
    this.mainStore.setCurrentUser(user);
    const currentSelected = user.clients?.find(
      (x) => x.id === this.mainStore.selectedClient?.id
    );

    if (user.clients && user.clients.length > 0 && currentSelected == null) {
      const isBBUser =
        this.mainStore.currentUser?.roles?.includes("SuperAdmin") ||
        this.mainStore.currentUser?.roles?.includes("BizboxAdmin") ||
        this.mainStore.currentUser?.roles?.includes("BizboxUser");
      const defaultClient = !isBBUser
        ? undefined
        : user.clients.find((c) => c.isDefault);
      const first = user.clients[0];
      if (!this.mainStore.selectedClient?.id) {
        this.mainStore.setSelectedClient(defaultClient || first);
      }
    }

    if (user.roles) {
      if (user.roles.length === 0) {
        this.notificationStore.setShowNoFacilityModal(true);
      }
    } else {
      this.notificationStore.setShowNoFacilityModal(true);
    }
  };

  handleCloseClientsDd = () => {
    this.mainStore.setClientsAnchorEl(null);
  };

  handleOpenClientsDd = (event: React.MouseEvent<HTMLElement>) => {
    this.mainStore.setClientsAnchorEl(event.currentTarget);
  };

  handleSelectClient = (
    client: clientModel,
    initialProductState: ProductListModel
  ) => {
    this.mainStore.setSelectedClient(client);
    this.handleCloseClientsDd();
    this.productDDStore.setSelected(undefined);

    /// Products Dropdown Reset
    const { selectedClient } = this.mainStore;
    const { pageNumber, pageSize } = this.productDDStore;
    queryClient.invalidateQueries({
      queryKey: [
        "products-dd",
        pageNumber,
        pageSize,
        encodeURIComponent(selectedClient?.id ?? ""),
      ],
    });

    /// Facilities Dropdown Reset
    this.facilityDDStore.setSelected(undefined);
    const selectedProductCode =
      this.facilityDDStore.selectedFacility?.facilityCode;
    queryClient.invalidateQueries({
      queryKey: [
        "facilities-dd",
        this.facilityDDStore.pageNumber,
        this.facilityDDStore.pageSize,
        selectedProductCode,
      ],
    });
  };
}
